import { IAddFormPublishTermsResponse } from '../../../../repositories/billing-tariffs/v3/add-form/publish-terms';
import { ILoadPublishTermsSuccess } from '../../types';
import type { IPromotion } from '../../../../repositories/billing-tariffs/entities/PublishTerms/Promotion';
import { mapRecommendedPackage } from '../../v2/utils/recommendedPackages';
import { mapPublication } from './mapPublication';
import { mapMoneySources } from './mapMoneySources';
import { mapPublicationPackages } from './mapPublicationPackages';
import { mapPromotion } from './mapPromotion';

export const mapResponse200 = (response: IAddFormPublishTermsResponse): ILoadPublishTermsSuccess => ({
  success: true,
  payload: {
    dataV2: {
      paidPublication: mapPublication(response.publication),
      moneySources: mapMoneySources(response.moneySources),
      promotion: mapPromotion(response.promotion as IPromotion, response.terms),
      publicationPackages: mapPublicationPackages(response.publicationPackages),
      recommendedPackages: response.recommendedPackages?.map(mapRecommendedPackage) || [],
    },
  },
});
